import React from "react";
import { Section, Field, TextField } from "./ReviewFields";

export default function TotalsSection({ extracted, upd }) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-[#E8E4D9] p-5 sm:p-6 mb-4">
      <Section title="TOTALI DOCUMENTO" testid="section-totali">
        <p className="text-xs text-zinc-600 mb-4 leading-relaxed">
          L&apos;imponibile è il <span className="font-semibold">totale della fattura originale</span> del fornitore estero (senza IVA).
          {" "}L&apos;IVA in reverse charge viene aggiunta automaticamente e il totale autofattura risulta = imponibile + IVA.
        </p>

        <div className="space-y-4">
          <Field label="Imponibile / totale fattura originale (EUR)" required>
            <TextField type="number" step="0.01" value={extracted.imponibile} onChange={upd("imponibile")} mono testid="field-imponibile" />
          </Field>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field label="IVA reverse charge (EUR)" hint="Calcolata come imponibile × aliquota.">
              <TextField type="number" step="0.01" value={extracted.imposta} onChange={upd("imposta")} mono testid="field-imposta" />
            </Field>
            <Field label="Totale autofattura (EUR)" hint="Imponibile + IVA: è il totale che andrà nell'XML SDI.">
              <TextField
                type="number"
                step="0.01"
                value={extracted.total_amount}
                onChange={upd("total_amount")}
                mono
                testid="field-total-amount"
                className="font-bold"
              />
            </Field>
          </div>
        </div>
      </Section>
    </div>
  );
}
